import { useMemo } from "react";
import { useParams } from "react-router";
import _ from "lodash";

import { colors } from "theme/palette";

import IconButton from "components/IconButton";
import Stack from "components/Stack";
import Text from "components/Text";

import { useDueDiligenceFilters } from "pages/Deal/DueDiligence/Filters";

import { useDealChecklistPermission } from "entities/Deal/sdk";
import { EFieldStatus } from "entities/Field/constants";
import { IField } from "entities/Field/sdk";
import FieldStatusIcon from "entities/Package/components/FieldStatusIcon";

interface IPrintableFieldTitle {
  field: IField;
}

const PrintableFieldTitle = ({ field }: IPrintableFieldTitle) => {
  const params = useParams<{
    dealId: string;
    packageId: string;
  }>();

  const dealId = useMemo(() => Number(params.dealId), [params.dealId]);
  const packageId = useMemo(() => Number(params.packageId), [params.packageId]);

  const { showApprovalBoxes } = useDueDiligenceFilters();
  const { data: userPermission } = useDealChecklistPermission({
    dealId,
    packageId,
  });

  const hideStatuses = useMemo(
    () =>
      _.isNil(userPermission) ||
      (!userPermission.has_write_access && !userPermission.is_full_access),
    [userPermission]
  );

  return (
    <Stack direction="row" spacing={0.5} sx={{ flex: 1 }} alignItems="center">
      {showApprovalBoxes && !hideStatuses && (
        <IconButton sx={{ opacity: 1 }}>
          <FieldStatusIcon status={field.status} />
        </IconButton>
      )}

      <Stack direction="row" spacing={0.5} alignItems="center">
        <Text
          variant="text2"
          sx={{
            color:
              field.status === EFieldStatus.NA ? colors.gray60 : colors.black,
            fontWeight: "bold",
          }}
          title={field.display_name}
        >
          {field.display_name}
        </Text>
      </Stack>
    </Stack>
  );
};

export default PrintableFieldTitle;
